import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import { CommunityAccessElement } from '@shared/dream-components';

import { COMMUNITY_ROUTES } from '~/constants/community';
import type { Community, CurrentCommunityMember } from '~/interfaces/community';
import type { Subscription } from '~/interfaces/subscriptions';

interface Props {
  community?: Community | null;
  currentCommunityMember?: CurrentCommunityMember | null;
  subscription: Subscription;
}

export const CommunitySection = ({ community, currentCommunityMember, subscription }: Props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const gatingTierName =
    community?.gated && community.premium_tier_ids.length > 0
      ? subscription.premium_tiers?.find((pt) => community.premium_tier_ids.includes(pt.id))?.name
      : undefined;

  return (
    <CommunityAccessElement
      element={{
        type: 'communityAccess',
        attrs: {
          data: {
            community: community
              ? {
                  name: community.name,
                  gated: community.gated,
                  community_accessible: community.community_accessible,
                }
              : null,
            isMember: Boolean(currentCommunityMember),
            isBanned: Boolean(currentCommunityMember?.banned),
          },
        },
      }}
      onClickButton={() => navigate(COMMUNITY_ROUTES.root)}
      translations={{
        'manage.community.title': t('manage.community.title', { defaultValue: 'Community' }),
        'manage.community.description': t('manage.community.description', {
          name: community?.name ?? '',
          defaultValue: 'Connect with other members of {{name}}.',
        }),
        'manage.community.cta_member': t('manage.community.cta_member', { defaultValue: 'Go to community' }),
        'manage.community.cta_join': t('manage.community.cta_join', { defaultValue: 'Join the community' }),
        ...(gatingTierName
          ? {
              'manage.community.tier_note': t('manage.community.tier_note', {
                tierName: gatingTierName,
                defaultValue: 'Community access is included with your {{tierName}} subscription.',
              }),
            }
          : {}),
      }}
    >
      {null}
    </CommunityAccessElement>
  );
};
